/* UserBlock — avatar + dropdown (canvas §04). Tokens only; no new interaction pattern —
   ported mechanics from narcis's userblock.module.scss, restyled to House. */

// Header ambient "Your muse" ghost link + ember dot (canvas 09 §04) — mirrors narcis's
// .avatarStatusDot/.avatarStatusDotPulse convention (userblock.module.scss), ember instead of
// yolk, a text link instead of a corner badge (ovid has no avatar to pin a badge to).
.ambientLink {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  font-family: var(--ov-grotesque);
  font-size: 13px;
  color: var(--ov-ivory);
  text-decoration: none;

  &:hover {
    color: var(--ov-ember);
  }
}

.ambientDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ov-ember);
  flex-shrink: 0;
}

// Ovid muses (Step 2) — her thumb in the header ambient link, flag-off world. 24x32 (2:3),
// matches the canvas's own header-avatar sizing (`Chosen.dc.html`/`PackOwner.dc.html`).
.ambientThumb {
  width: 24px;
  height: 32px;
  flex-shrink: 0;
  object-fit: cover;
  display: block;
  border: 1px solid var(--ov-line-strong);
  background: var(--ov-raise);
}

.ambientDotPulse {
  animation: ambientDotPulse 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

@keyframes ambientDotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.wrap {
  position: relative;
  flex-shrink: 0;
}

.avatar {
  width: 30px;
  height: 30px;
  border: 1px solid var(--ov-line-strong);
  background: var(--ov-panel);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--ov-display);
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  color: var(--ov-ivory);
  cursor: pointer;
  transition: border-color var(--ov-dur-1) var(--ov-ease), background var(--ov-dur-1) var(--ov-ease);

  &:hover {
    border-color: var(--ov-ivory);
  }

  &[aria-expanded='true'] {
    background: var(--ov-raise);
  }
}

.dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 232px;
  background: var(--ov-panel);
  border: 1px solid var(--ov-line-strong);
  box-shadow: 0 12px 32px rgba(0, 0, 0, .45);
  z-index: 5;
}

.who {
  padding: 12px 16px 10px;
  font-family: var(--ov-grotesque);
  font-size: 12px;
  color: var(--ov-dim);
  border-bottom: 1px solid var(--ov-line);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item {
  display: block;
  width: 100%;
  padding: 11px 16px;
  font-family: var(--ov-grotesque);
  font-size: 13.5px;
  font-weight: 400;
  color: var(--ov-ivory);
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.4;
  transition: background var(--ov-dur-1) var(--ov-ease);

  &:hover {
    background: var(--ov-raise);
  }
}

.itemTail {
  color: var(--ov-dim);
}
